var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgChevronDownOutline = function SvgChevronDownOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65 11.24a1 1 0 10-1.3 1.52l7 6a1 1 0 001.3 0l7-6a1 1 0 00-1.3-1.52L14 16.684 7.65 11.24z",
    fill: "#023F80"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNjUwODEgMTEuMjQwOEM3LjIzMTQ4IDEwLjg4MTMgNi42MDAxOCAxMC45Mjk5IDYuMjQwNzYgMTEuMzQ5MkM1Ljg4MTM0IDExLjc2ODYgNS45Mjk5IDEyLjM5OTkgNi4zNDkyMyAxMi43NTkzTDEzLjM0OTIgMTguNzU5M0MxMy43MjM3IDE5LjA4MDMgMTQuMjc2MyAxOS4wODAzIDE0LjY1MDggMTguNzU5M0wyMS42NTA4IDEyLjc1OTNDMjIuMDcwMSAxMi4zOTk5IDIyLjExODcgMTEuNzY4NiAyMS43NTkzIDExLjM0OTJDMjEuMzk5OSAxMC45Mjk5IDIwLjc2ODYgMTAuODgxMyAyMC4zNDkyIDExLjI0MDhMMTQgMTYuNjgyOUw3LjY1MDgxIDExLjI0MDhaIiBmaWxsPSIjMDIzRjgwIi8+Cjwvc3ZnPgo=";
export { SvgChevronDownOutline as ReactComponent };